module.exports = __webpack_public_path__ + "static/media/sign-on-widget-spinner.eea28db2.gif";